import React from "react";
import AceEditorInput from "@/components/ace-editor-input/AceEditorInput";
import { useTheme } from "@/components/ThemeProvider";

export default function AceEditorField({ form, field, ...otherProps }) {
  const { isDarkMode } = useTheme();
  return <AceEditorInput {...otherProps} theme={isDarkMode ? "tomorrow_night" : "gruvbox"} />;
}
